import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import KakobuyVsCssbuyPage from "../pages/articles/kakobuy-vs-cssbuy/page";
import SafetyGuidePage from "../pages/articles/safety-guide/page";
import BestFindsPage from "../pages/articles/best-finds/page";
import SuperbuyGuidePage from "../pages/articles/superbuy-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/kakobuy-vs-cssbuy",
    element: <KakobuyVsCssbuyPage />,
  },
  {
    path: "/artykul/bezpieczenstwo-zakupow",
    element: <SafetyGuidePage />,
  },
  {
    path: "/artykul/najlepsze-finds-2026",
    element: <BestFindsPage />,
  },
  {
    path: "/artykul/superbuy-spreadsheet-poradnik",
    element: <SuperbuyGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;